module.exports = __webpack_public_path__ + "img/kaktusz.bedb418b.png";